/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PhoneIcon from '../../../assets/phone-icon.svg';
import HouseIcon from '../../../assets/house-icon.svg';
import { useMemberData } from '../context/MemberDataContext';
import { EmailInput } from './Inputs/EmailInput';
import { PhoneInput } from './Inputs/PhoneInput';
import { ConfirmEmailInput } from './Inputs/EmailConfirmInput';
import { EmailRecaptcha } from './Inputs/EmailRecaptcha';

export function AccessFormSimplified() {
  const memberData = useMemberData();
  const { t } = useTranslation('user_data_confirmation');
  const { t: t2 } = useTranslation('redo-register-v2');
  const streetName = memberData.data.streetName;
  const streetNumber = memberData.data.streetNumber;

  return (
    <div className="access-form-container" data-testid="first-access-form-simplified">
      <div className="access-form-header" data-testid="first-access-contact-header">
        <img src={PhoneIcon} alt="phone icon" />
        <h3>{t2('contact_label')}</h3>
      </div>

      <div className="access-form-content" data-testid="first-access-contact-content">
        <div>
          <EmailInput />

          <span className="email-warning" data-testid="first-access-email-warning">
            {t('avoid_corporate_emails')}
          </span>
        </div>
        <ConfirmEmailInput />
        <PhoneInput />
        <EmailRecaptcha />
      </div>

      <div className="form-divider" />

      <div className="access-form-footer" data-testid="first-access-address-footer">
        <img src={HouseIcon} alt="house icon" />

        <div data-testid="first-access-address-info">
          {t('address_info_1')}{' '}
          <strong>
            {streetName}, {streetNumber}
          </strong>
          {t('address_info_2')}
        </div>
      </div>
    </div>
  );
}
